import { ButtonAlt, Input } from 'ui/components/primitives';
import { styled, theme, utils } from 'ui/theme';

const QuantitySelector = {
  Component: styled.div`
    ${utils.flexbox.row.centerStretch};
    border-radius: ${theme.radii.small};
    border: solid ${theme.borderWidths.hairline} ${theme.colors.build.mediumMedium};
    height: ${theme.sizes[12]};
    font-size: ${theme.fontSizes.sm};
    overflow: hidden;

    &[data-size='small'] {
      height: ${theme.sizes[8]};
    }

    &[data-size='medium'] {
      height: ${theme.sizes[12]};
    }

    &[data-size='large'] {
      height: ${theme.sizes[16]};
    }
  `,

  Button: styled(ButtonAlt)`
    ${utils.flexbox.row.centerCenter};
    border-radius: ${theme.radii.sharp};
    color: ${theme.colors.action.navigation.standard.static};
    height: 100%;
    padding: ${theme.space[2]};

    &:disabled {
      background: transparent;
      color: ${theme.colors.build.mediumLight2};
    }

    & svg {
      justify-self: center;
      align-self: center;
    }
  `,

  InputQuantity: styled(Input)`
    border-radius: none;
    border: none;
    box-shadow: none;
    color: ${theme.colors.build.darkLight};
    height: 100%;
    padding: 0;
    text-align: center;

    &:focus-visible {
      outline: none;
    }

    &:focus,
    &:focus-visible {
      box-shadow: none;
      outline: none;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    &[type='number'] {
      -moz-appearance: textfield;
    }
  `,
};

export default QuantitySelector;
